import React from 'react'
import { ApolloProvider } from '@apollo/react-hooks'
import ApolloClient from 'apollo-boost'
import { Route, Redirect } from 'react-router-dom'
import { isLoggedIn } from '../utils/api'
import { apiUrl } from '../utils/constants'

const client = new ApolloClient({
  uri: `${apiUrl}graphql`,
  headers: {
    authorization: `Bearer ${isLoggedIn()}`,
  },
})

const ApolloRoute = ({ component: Component, ...rest }) => (
  <ApolloProvider client={client}>
    <Route
      {...rest}
      render={(props) => {
        if (window.Appcues) {
          window.Appcues.start()
          window.Appcues.page()
        }
        return isLoggedIn() ? <Component {...props} /> : <Redirect to={{ pathname: `/` }} />
      }}
    />
  </ApolloProvider>
)

export default ApolloRoute



// WEBPACK FOOTER //
// ./src/graphql/ApolloRoute.js